import { useEffect, useState } from 'react';
import { ActivityIndicator, Modal, Pressable, Text, View } from 'react-native';
import { useAuth } from '../auth/AuthContext';
import { useSync } from '../store/store';
import { Btn, Field } from './ui';
import { C } from './theme';
import { t } from '../lib/i18n';
import { mascaraCpf } from '../lib/cpf';

const COR = '#3B82F6';

/** Janela "Entrar de novo": a sessão no servidor venceu, mas tudo o que está no aparelho continua. */
export function ReentrarModal({ visivel, onFim }: { visivel: boolean; onFim: () => void }) {
  const a = useAuth();
  const [senha, setSenha] = useState('');
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  const fechar = () => { setSenha(''); setMsg(''); onFim(); };
  async function ok() {
    if (!senha) return;
    setBusy(true); setMsg('');
    try { await a.reentrar(senha); fechar(); }
    catch (e: any) { setMsg(String(e?.message ?? e)); }
    finally { setBusy(false); }
  }
  return (
    <Modal visible={visivel} transparent animationType="fade" onRequestClose={fechar}>
      <Pressable onPress={fechar} style={{ flex: 1, backgroundColor: C.overlay, justifyContent: 'center', padding: 20 }}>
        <Pressable style={{ backgroundColor: C.card, borderRadius: 20, padding: 20, gap: 12, maxWidth: 480, width: '100%', alignSelf: 'center', borderWidth: 1, borderColor: COR }}>
          <Text style={{ fontSize: 36, textAlign: 'center' }}>☁️</Text>
          <Text style={{ color: C.text, fontWeight: '800', fontSize: 18, textAlign: 'center' }}>{t('Confirme sua senha para sincronizar')}</Text>
          <Text style={{ color: C.sub, fontSize: 13, textAlign: 'center' }}>
            {t('Sua conexão com a nuvem venceu (acontece quando o app fica muito tempo sem abrir ou a senha foi trocada em outro dispositivo). Nada se perde: o que está aqui é enviado assim que você confirmar.')}
          </Text>
          {!!a.cpf && <Text style={{ color: C.text, textAlign: 'center', fontWeight: '700' }}>CPF {mascaraCpf(a.cpf)}</Text>}
          <Field value={senha} onChangeText={setSenha} placeholder={t('Senha da conta')} secureTextEntry autoCapitalize="none" onSubmitEditing={ok} autoFocus />
          {!!msg && <Text style={{ color: C.danger }}>{msg}</Text>}
          {busy ? <View style={{ padding: 14, alignItems: 'center' }}><ActivityIndicator color={COR} /></View>
            : <Btn cor={COR} label={t('Entrar de novo')} onPress={ok} />}
          <Pressable onPress={fechar} style={{ alignItems: 'center', padding: 6 }}><Text style={{ color: C.sub }}>{t('Depois')}</Text></Pressable>
        </Pressable>
      </Pressable>
    </Modal>
  );
}

let avisado = false;
/** Aparece sozinho uma vez quando a sincronização para por sessão vencida. */
export function SessaoAviso() {
  const s = useSync();
  const [ver, setVer] = useState(false);
  useEffect(() => { if (s.status === 'sessao' && !avisado) { avisado = true; setVer(true); } }, [s.status]);
  return <ReentrarModal visivel={ver} onFim={() => setVer(false)} />;
}
